// Redesign 2026 – sekce „Žádost o informaci“ (includes/template-parts/redesign/ask.php, Fluent Form 6).
// Text tlačítka podle návrhu („Odeslat dotaz“) – filtr renderu tlačítka FF na této verzi nezabírá,
// proto stejně jako u objednávky (order.js) přes JS.
export default function initRedesignAsk() {
  document.querySelectorAll('[data-rd-ask] .ff-btn-submit').forEach((button) => {
    button.textContent = 'Odeslat dotaz';
    button.setAttribute('aria-label', 'Odeslat dotaz');
  });
}
